export default __webpack_public_path__ + "static/TwoColumnCarouselBg-034379421243ea412d5d9bb5f08b8ac5.png";